"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InvoiceLinesView = class InvoiceLinesView extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getQueryParameters(...args) {
        return {
            company_id: this.companyId,
            partner_id: this.partnerId,
            rental_id: this.rentalId,
            contract_id: this.contractId,
        };
    }
    companyId;
    onCompany_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("companyId");
    }
    partnerId;
    onPartner_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("partnerId");
    }
    rentalId;
    onRental_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rentalId");
    }
    contractId;
    onContract_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contractId");
    }
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('browse_invoice_lines', { parameters: this.getQueryParameters });
    }
    ux;
    b_7315092382398562_columnDefaults;
    b_7315092382398562_columns;
    dataMembers = ['ds', 'ux', 'b_7315092382398562_columnDefaults', 'b_7315092382398562_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ds: null,
                ux: null,
                b_7315092382398562_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_7315092382398562_columns: [{
                        field: "invoice_kind",
                        name: this.$fn.pgettext("Invoice", "Invoice kind"),
                    },
                    {
                        field: "invoice_type",
                        name: this.$fn.pgettext("Invoice", "Invoice type"),
                    },
                    {
                        field: "invoice_number",
                        name: this.$fn.pgettext("Invoice", "Invoice number"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "invoice",
                            params: {
                                id: "invoice_id",
                            },
                        },
                    },
                    {
                        field: "invoice_date",
                        name: this.$fn.pgettext("Invoice", "Invoice date"),
                        type: "date",
                    },
                    {
                        field: "fulfillment_date",
                        name: this.$fn.pgettext("Invoice", "Fulfillment date"),
                        type: "date",
                    },
                    {
                        field: "description",
                        name: this.$fn.pgettext("InvoiceLine", "Description"),
                    },
                    {
                        field: "quantity",
                        name: this.$fn.pgettext("InvoiceLine", "Quantity"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "unit",
                        name: this.$fn.pgettext("InvoiceLine", "Unit"),
                    },
                    {
                        field: "unit_price",
                        name: this.$fn.pgettext("InvoiceLine", "Price"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "discount",
                        name: this.$fn.pgettext("InvoiceLine", "Discount"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "net_amount",
                        name: this.$fn.pgettext("InvoiceLine", "Net"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "vat_amount",
                        name: this.$fn.pgettext("InvoiceLine", "VAT"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "amount",
                        name: this.$fn.pgettext("InvoiceLine", "Amount"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "tax_code",
                        name: this.$fn.pgettext("InvoiceLine", "Tax Code"),
                    },
                    {
                        field: "currency",
                        name: this.$fn.pgettext("Invoice", "Currency"),
                    },
                    {
                        field: "billing_period_start",
                        name: this.$fn.pgettext("Invoice", "Period start"),
                        type: "date",
                    },
                    {
                        field: "billing_period_end",
                        name: this.$fn.pgettext("Invoice", "Period end"),
                        type: "date",
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    async act_7315092382398562_setData_7766_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_7315092382398562_selectedRowsChanged(event, scope) {
        return await this.actions.evh_7315092382398562_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_setData_7766 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7315092382398562_setData_7766_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_selectedRowsChanged_7765 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_setData_7766,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_7315092382398562_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_selectedRowsChanged_7765],
        });
        return {
            act_7315092382398562_setData_7766,
            evh_7315092382398562_selectedRowsChanged_7765,
            evh_7315092382398562_selectedRowsChanged,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceLinesView.prototype, "companyId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('companyId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLinesView.prototype, "onCompany_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceLinesView.prototype, "partnerId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('partnerId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLinesView.prototype, "onPartner_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceLinesView.prototype, "rentalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rentalId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLinesView.prototype, "onRental_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceLinesView.prototype, "contractId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contractId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLinesView.prototype, "onContract_id", null);
InvoiceLinesView = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoiceLinesView);
exports.default = InvoiceLinesView;
vue_property_decorator_1.Vue.component("InvoiceLinesView", InvoiceLinesView);
